import httpService from '../httpService';
import { Task, TaskStatus } from '../../models/taskService.model';
import { store } from '../../redux/store';
import { setTasks, updateTask as updateTaskAction } from '../../redux/slices/tasksSlice';
import { getSelectedCommunity } from '../../hooks/community/useSelectedCommunity';
import { RootState } from '../../redux/reducers';

export const taskService = {
  createTask: async (
    communityId: number,
    name: string,
    dueDate?: Date,
    assignees?: number[],
    statusId?: number,
    description?: string,
  ) => {
    return httpService.post(`/networks/communities/${communityId}/tasks`, {
      communityId,
      name,
      description,
      dueDate,
      assignees,
      statusId,
    });
  },

  getAllTasksForCommunity: async (communityId: number): Promise<Task[]> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/communities/${selectedCommunity}/tasks`);
    store.dispatch(setTasks({ communityId, tasks: res.data }));
    return res.data;
  },

  getTaskById: async (taskId: number) => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    return httpService.get(`/networks/communities/${selectedCommunity}/tasks/${taskId}`);
  },

  updateTask: async (
    taskId: number,
    updates: { name?: string; description?: string; dueDate?: Date; statusId?: number | null },
  ) => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    return httpService.put(`/networks/communities/${selectedCommunity}/tasks/${taskId}`, updates);
  },

  moveToStatus: async (task: Task, status: TaskStatus, communityId: number): Promise<Task | void> => {
    if (!task.taskId) {
      return;
    }
    const res = await httpService.put(`/networks/communities/${communityId}/tasks/${task.taskId}`, {
      statusId: status.statusId,
    });
    store.dispatch(updateTaskAction({ communityId, task: res.data }));
  },

  deleteTask: async (taskId: number) => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    return httpService.delete(`/networks/communities/${selectedCommunity}/tasks/${taskId}`);
  },

  assignMemberToTask: async (taskId: number, userId: number, communityId: number) => {
    return httpService.post(`/networks/communities/${communityId}/tasks/${taskId}/assign/${userId}`);
  },

  removeMemberFromTask: async (taskId: number, userId: number, communityId: number) => {
    return httpService.delete(`/networks/communities/${communityId}/tasks/${taskId}/remove/${userId}`);
  },

  getStatuses: async (communityId: number): Promise<TaskStatus[]> => {
    const res = await httpService.get(`/networks/communities/${communityId}/task-statuses`);
    return res.data;
  },

  createStatus: async (communityId: number, name: string, color?: string): Promise<TaskStatus> => {
    const res = await httpService.post(`/networks/communities/${communityId}/task-statuses`, { name, color });
    return res.data;
  },

  updateStatus: async (
    communityId: number,
    statusId: number,
    data: { name?: string; color?: string; order?: number },
  ): Promise<TaskStatus> => {
    const res = await httpService.put(`/networks/communities/${communityId}/task-statuses/${statusId}`, data);
    return res.data;
  },

  deleteStatus: async (communityId: number, statusId: number): Promise<void> => {
    await httpService.delete(`/networks/communities/${communityId}/task-statuses/${statusId}`);
  },
};
